import { useCallback, useState } from 'react';
import { Download } from 'lucide-react';
import { BaseAnalyticsFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import AnalyticsExportPanel from '../AnalyticsExportPanel';

interface AnalyticsExportButtonProps {
  filters: BaseAnalyticsFilter;
}

export default function AnalyticsExportButton({ filters }: AnalyticsExportButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = useCallback(() => setIsOpen(false), []);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-[color-mix(in_srgb,var(--anl-accent)_60%,transparent)] bg-[color-mix(in_srgb,var(--anl-accent)_15%,transparent)] px-3 py-1.5 text-xs font-medium text-white transition-colors hover:border-[var(--anl-accent)] hover:bg-[color-mix(in_srgb,var(--anl-accent)_30%,transparent)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--anl-accent)]"
      >
        <Download className="h-3.5 w-3.5" aria-hidden />
        Export
      </button>
      <AnalyticsExportPanel isOpen={isOpen} onClose={handleClose} filters={filters} />
    </>
  );
}
